"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uid = uid;
let n = 0;
function uid() {
    return n++;
}
//# sourceMappingURL=uid.js.map